"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BetFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var BetFactory = /** @class */ (function (_super) {
    __extends(BetFactory, _super);
    function BetFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    BetFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    BetFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    BetFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    BetFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    BetFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return BetFactory;
}(contracts_1.ContractFactory));
exports.BetFactory = BetFactory;
var _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: '_ender',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: '_contractAddress',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint8',
                name: '_result',
                type: 'uint8',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: '_platformFee',
                type: 'uint256',
            },
        ],
        name: 'EndBetContract',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: '_betAddress',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: '_bettorAddress',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'uint8',
                name: '_choice',
                type: 'uint8',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: '_betTokensInExaEs',
                type: 'uint256',
            },
        ],
        name: 'NewBetting',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'previousOwner',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'newOwner',
                type: 'address',
            },
        ],
        name: 'OwnershipTransferred',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: '_to',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: '_tokensInExaEs',
                type: 'uint256',
            },
        ],
        name: 'TransferES',
        type: 'event',
    },
    {
        inputs: [],
        name: '_owner',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        name: 'betBalanceInExaEs',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        name: 'bettorBetAmountInExaEsByChoice',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        name: 'bettorHasClaimed',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'category',
        outputs: [
            {
                internalType: 'uint8',
                name: '',
                type: 'uint8',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'creationTimestamp',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'dayswappers',
        outputs: [
            {
                internalType: 'contract IDayswappers',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'description',
        outputs: [
            {
                internalType: 'string',
                name: '',
                type: 'string',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'downVotes',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'downvote',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint8',
                name: '_choice',
                type: 'uint8',
            },
        ],
        name: 'endBet',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'endTimestamp',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'endedBy',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint8',
                name: '_choice',
                type: 'uint8',
            },
        ],
        name: 'enterBet',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'finalResult',
        outputs: [
            {
                internalType: 'uint8',
                name: '',
                type: 'uint8',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        name: 'getNumberOfChoiceBettors',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_owner1',
                type: 'address',
            },
            {
                internalType: 'string',
                name: '_description',
                type: 'string',
            },
            {
                internalType: 'uint8',
                name: '_category',
                type: 'uint8',
            },
            {
                internalType: 'uint8',
                name: '_subCategory',
                type: 'uint8',
            },
            {
                internalType: 'uint256',
                name: '_minimumBetInExaEs',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: '_prizePercentPerThousand',
                type: 'uint256',
            },
            {
                internalType: 'bool',
                name: '_isDrawPossible',
                type: 'bool',
            },
            {
                internalType: 'uint256',
                name: '_pauseTimestamp',
                type: 'uint256',
            },
            {
                internalType: 'address',
                name: '_kycDapp',
                type: 'address',
            },
        ],
        name: 'initialize',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'isDrawPossible',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'kycDapp',
        outputs: [
            {
                internalType: 'contract IKycDapp',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'minimumBetInExaEs',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'nrtManager',
        outputs: [
            {
                internalType: 'contract INRTManager',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'owner',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'pauseTimestamp',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'prepaidEs',
        outputs: [
            {
                internalType: 'contract IPrepaidEs',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'prizePercentPerThousand',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'randomnessManager',
        outputs: [
            {
                internalType: 'contract RandomnessManager',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: '_username',
                type: 'bytes32',
            },
        ],
        name: 'resolveAddress',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: '_username',
                type: 'bytes32',
            },
        ],
        name: 'resolveAddressStrict',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_wallet',
                type: 'address',
            },
        ],
        name: 'resolveUsername',
        outputs: [
            {
                internalType: 'bytes32',
                name: '',
                type: 'bytes32',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_wallet',
                type: 'address',
            },
        ],
        name: 'resolveUsernameStrict',
        outputs: [
            {
                internalType: 'bytes32',
                name: '',
                type: 'bytes32',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_bettorAddress',
                type: 'address',
            },
        ],
        name: 'seeWinnerPrize',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_kycDapp',
                type: 'address',
            },
        ],
        name: 'setKycDapp',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'subCategory',
        outputs: [
            {
                internalType: 'uint8',
                name: '',
                type: 'uint8',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'timeallyClub',
        outputs: [
            {
                internalType: 'contract ITimeAllyClub',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'timeallyManager',
        outputs: [
            {
                internalType: 'contract ITimeAllyManager',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'timeallyPromotionalBucket',
        outputs: [
            {
                internalType: 'contract ITimeAllyPromotionalBucket',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        name: 'totalBetTokensInExaEsByChoice',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'totalContractBalance',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'totalPrize',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'newOwner',
                type: 'address',
            },
        ],
        name: 'transferOwnership',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'upVotes',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'upvote',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'validatorManager',
        outputs: [
            {
                internalType: 'contract IValidatorManager',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address payable',
                name: '_bettorAddress',
                type: 'address',
            },
        ],
        name: 'withdrawPrize',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
];
var _bytecode = '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';
//# sourceMappingURL=BetFactory.js.map